import Vue from "vue";
import Router from "vue-router";
import Projects from "./views/Projects.vue";
import VueGtag from "vue-gtag";
import VueMeta from "vue-meta";

Vue.use(Router);
Vue.use(VueMeta);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Projects,
    },
    {
      path: "/projects",
      name: "projects",
      component: Projects,
    },
    {
      path: "/projects/:id",
      name: "folio-item",
      component: Projects,
    },
  ],
});

Vue.use(
  VueGtag,
  {
    config: {
      id: "G-H16KNM5H6W",
    },
  },
  router
);

export default router;
